import React from 'react';
import { labelStyles, LabelProps } from './styles';

const Label16: React.FC<LabelProps> = ({
    children,
    className,
    style,
    isBold,
    isPrimary,
    onClick,
}) => {
    const { label16Styles, primary, bold } = labelStyles();
    const classes = `${className} ${label16Styles} ${
        isPrimary ? primary : ''
    } ${isBold ? bold : ''}`;
    return (
        <div className={classes} style={style} onClick={onClick}>
            {children}
        </div>
    );
};

export default Label16;
